import branch from "utils/json/branch.json";
import vendor from "utils/json/vendor.json";
import user from "utils/json/user.json";
import hub from "utils/json/hub.json";
import financialPeriod from "utils/json/financial-period.json";
import food from "utils/json/food.json";
import receiving from "utils/json/receiving.json";
import hubOps from "utils/json/hub-ops.json";
import stocks from "utils/json/stocks.json";
import report from "utils/json/report.json";
import good from "utils/json/good.json";
import bundle from "utils/json/bundle.json";
import payment from "utils/json/payment.json";
import ordersDaily from "utils/json/orders-daily.json";
import taxInvoice from "utils/json/tax-invoice.json";
import topping from "utils/json/topping.json";
import batch from "utils/json/batch.json";
import assignBatch from "utils/json/assignBatch.json";
import offlineInvoice from "utils/json/offline-invoice-sell.json";
import shelf from "utils/json/shlef.json";
import cpc from "utils/json/cpc-invoices.json";
import customer from "utils/json/customer.json";
import foodType from "utils/json/foodType.json";
import receivingTime from "utils/json/receivingTime.json";
import vendorInvoice from "utils/json/vendor-invoice.json";

type Dictionary = { [index: string]: any };

const jsons: Dictionary = {
    branch,
    vendor,
    user,
    hub,
    food,
    payment,
    receiving,
    bundle,
    report,
    stocks,
    good,
    taxInvoice,
    ordersDaily,
    offlineInvoice,
    topping,
    batch,
    assignBatch,
    "hub-ops": hubOps,
    "financial-period": financialPeriod,
    shelf,
    cpc,
    customer,
    foodType,
    receivingTime,
    vendorInvoice,
};

export default jsons;
